import axios from '@/zenky'
import config from '@/config'
import storage, { keys as storageKeys } from '@/storage'
import router from '@/router';

export default {
  namespaced: true,

  state: {
    token: '',
    user: {},
    loyaltyProfile: null,
    balanceIsAdjusting: false,
  },

  getters: {
    hasToken(state) {
      return !!state.token
    },

    hasUser(state) {
      return !!state.user?.id
    },

    user(state) {
      return state.user
    },

    userAvatar(state, getters) {
      if (!getters.hasUser) {
        return ''
      }

      if (getters.user.media && getters.user.media.avatar && getters.user.media.avatar.medium_url) {
        return getters.user.media.avatar.medium_url
      }

      return getters.user.default_avatar_url
    },

    userAvatarMedia(state, getters) {
      if (!getters.hasUser) {
        return null
      }

      if (!!getters.user.media && !!getters.user.media.avatar && !!getters.user.media.avatar.id) {
        return getters.user.media.avatar
      }

      return null
    },

    loyaltyProfile(state) {
      return state.loyaltyProfile
    },

    referralProgram(state) {
      return state?.user?.customer?.loyalty?.referral_program || null
    },

    balanceIsAdjusting(state) {
      return state.balanceIsAdjusting === true
    },
  },

  mutations: {
    setToken(state, token) {
      state.token = token
    },

    setUser(state, user) {
      state.user = user
    },

    setLoyaltyProfile(state, newVal) {
      state.loyaltyProfile = newVal;
    },

    setBalanceIsAdjusting(state, value) {
      state.balanceIsAdjusting = value
    },
  },

  actions: {
    initUser({ dispatch, commit }) {
      return new Promise((resolve, reject) => {
        const token = storage.accessToken()

        if (!token) {
          return resolve()
        }

        commit('setToken', token)
        axios.defaults.headers['Authorization'] = `Bearer ${token}`

        axios.get(`profile?with=${config.includes.profile}`)
          .then(({ data }) => {
            commit('setUser', data.data)
            return resolve(data.data)
          })
          .catch(err => reject(err))
      })
    },

    initUserFromToken({ dispatch }, token) {
      return new Promise((resolve, reject) => {
        storage.accessToken(token)
        dispatch('initUser')
          .then(data => resolve(data))
          .catch(err => reject(err))
      })
    },

    logIn({ dispatch, commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('auth/login', payload)
          .then(({ data }) => {
            storage.accessToken(data.data.token)
            commit('setUser', data.data.user)
            dispatch('initUser')
            resolve(data.data.user)
          })
          .catch(err => reject(err))
      })
    },

    async resetPassword({ dispatch, commit }, payload) {
      const { token, user } = (await axios.post('/auth/password/reset', payload)).data.data;
      storage.accessToken(token)
      commit('setUser', user)
      dispatch('initUser')
    },

    async confirmRegistration({ dispatch, commit }, payload) {
      const { token, user } = (await axios.post('/auth/register/confirm', payload)).data.data;
      storage.accessToken(token)
      commit('setUser', user)
      dispatch('initUser')
    },

    logout() {
      storage.clearAllBut([storageKeys.CITY_ID, storageKeys.STORE, storageKeys.CATEGORIES_TREE]);
      router.push({ name: 'home' });
      location.reload();
    },

    async loadLoyaltyProfile({ commit }) {
      const res = await axios.get('/loyalty/profile');
      commit('setLoyaltyProfile', res.data.data);
    },

    async dispatchBalanceAdjustment({ commit }) {
      commit('setBalanceIsAdjusting', true);
      storage.nextBalanceAdjustment(new Date().getTime() + (60 * 5 * 1000));
      await axios.post('/loyalty/profile/balance/adjust');
    },
  },
}
